import React from "react";

const Footer = () => {
  return (
    <div className="footer-bg admin-footer">
      <div className="admin-footer-wrapper">
        <img className="footer-logo" src="/footer-logo.png" alt="Logo" />{" "}
        <p>
          <span>Copyright © 2026 Singapore Green Building Council </span>{" "}
          <span className="px-3"></span>
          <span>UEN: 201025079H</span>
        </p>
      </div>
      <div className="admin-footer-wrapper">
        <p>
          <span>Powered by Flying Cape Technologies</span>
        </p>
      </div>
    </div>
  );
};

export default Footer;
